import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import SkeletProfile from 'Skelet/src/components/Profile.js'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined} from 'Skelet/src/modules/fetch.action.js'


class Profile extends React.Component {

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "profile", "GET", config.api_url+"/profile?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "profile", "GET", config.api_url+"/profile?t="+nextProps.session_token);
    }
  }

  render() {
    return <div className="container thin-container" style={{marginTop:"2em"}}>
      <SkeletProfile
        lang = "NL"
        config = {config}
        fields = {[{type:"text", dbcol:"username", placeholder:"Gebruikersnaam *", maxLength:"64"},
        {type:"text", dbcol:"biography", placeholder:"Biografie", maxLength:"500"},
        {type:"text", dbcol:"link1", placeholder:"Link 1", maxLength:"128"},
        {type:"text", dbcol:"link2", placeholder:"Link 2", maxLength:"128"},
        {type:"text", dbcol:"link3", placeholder:"Link 3", maxLength:"128"}]}
        required_fields = {[{dbcol:"username", name:"Gebruikersnaam"}]}
        validate_fields = {[{dbcol:"username", name:"Gebruikersnaam"}]}
        api_method = "PATCH"
        api_endpoint = "/profile-update"
        api_block = "update_profile"
        api_block_clear = "profile"
      />
    </div>;
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile)



// WEBPACK FOOTER //
// ./src/containers/Profile.js